module.exports = __webpack_public_path__ + "static/media/tree_28.bfe22f50.jpeg";